import { required, numeric, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      starting_cash: {
        required: helpers.withMessage(i18n.global.t('Please enter a starting cash.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the starting cash.'), numeric)
      },
      started_at: {
        required: helpers.withMessage(i18n.global.t('Please enter a started at.'), required),
      },
      note: {
      }
    }
  }
};
